var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"abas no-print"},_vm._l((_vm.abas),function(aba,index){return _c('div',{key:index},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.ativaAba(aba.aba)),expression:"ativaAba(aba.aba)"}],class:[
        aba.classe,
        'aba-container',
        { ativo: _vm.abaAtiva == aba.tipo },
        {
          'loading-desabilita': _vm.loadingResultado && _vm.abaAtiva != aba.tipo
        }
      ],on:{"click":function($event){_vm.controleAbas(aba.tipo, false, true)}}},[_vm._v(_vm._s(aba.nome)+"\n      "),(_vm.loadingResultado && _vm.abaAtiva == aba.tipo)?_c('LineLoading',{staticClass:"aba-loading",attrs:{"color":"var(--branco)"}}):_vm._e()],1)])}))}
var staticRenderFns = []

export { render, staticRenderFns }